export default "__VITE_ASSET__DRVn0i_3__"